import { useEffect } from "react";
import { BrowserRouter, Outlet, Route, Routes, useLocation } from "react-router-dom";
import AppContainer from "../Appcontainer";
import JobApply from "../../views/pages/Administration/Jobs/pages/PublicJobList/JobApply";
import JobList from "../../views/pages/Administration/Jobs/pages/PublicJobList/JobList";
import JobView from "../../views/pages/Administration/Jobs/pages/PublicJobList/jobDetail";
import ChangePassword from "../../views/pages/Authentication/ChangePassword";
import ForgotPassword from "../../views/pages/Authentication/ForgotPassword";
import Login from "../../views/pages/Authentication/Login";
import AcceptInvitation from "../../views/pages/Authentication/acceptInvitation";
import LeaveApproval from "../../views/pages/Authentication/leaveApproval";
import ResetPassword from "../../views/pages/Authentication/resetPassword";
import Error404 from "../../views/pages/Error/Error404";
import Error500 from "../../views/pages/Error/Error500";
import { useAuth } from "context/userContext";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom/dist";
import { fetchCostCenterData, fetchCurrentApproversData, fetchDepartment, fetchDivision, fetchDocumentSubType, fetchNationality, fetchPosition, fetchReligion, fetchReportTo, fetchUniformSizesData, fetchUserData } from "store/slice/common";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRouter = () => {
  const { token } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchNationality());
    if (token) {
      dispatch(fetchDivision());
      dispatch(fetchDepartment());
      dispatch(fetchPosition());
      dispatch(fetchReligion());
      dispatch(fetchReportTo());
      dispatch(fetchDocumentSubType());
      dispatch(fetchUserData());
      dispatch(fetchCostCenterData());
      dispatch(fetchUniformSizesData());
      dispatch(fetchCurrentApproversData());
    }
  }, [token, dispatch]);

  const PublicRoute = ({ redirectTo }) => { return token ? <Navigate to={redirectTo} /> : <Outlet />; };
  const ProtectedRoute = ({ redirectTo }) => { return token ? <Outlet /> : <Navigate to={redirectTo} />; };

  const RootRedirect = () => {
    return token ? <Navigate to="/employee-dashboard" /> : <Navigate to="/login" />;
  };

  return (
    <div>
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route element={<PublicRoute redirectTo="/employee-dashboard" />}>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/error-404" element={<Error404 />} />
            <Route path="/error-500" element={<Error500 />} />
          </Route>

          <Route element={<ProtectedRoute redirectTo="/login" />}>
            <Route path="/*" element={<AppContainer />} />
          </Route>

          <Route path="/job-view" element={<JobList />} />
          <Route path="/job-view/:id" element={<JobView />} />
          <Route path="/job-apply/:id" element={<JobApply />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/invitation" element={<AcceptInvitation />} />
          <Route path="/service/leave-request" element={<LeaveApproval />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AppRouter;
